
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const InfoRoundButton = ({ message, onClick, icon }) => {
  return (
    <OverlayTrigger
      placement="right"
      overlay={<Tooltip id="tooltip-info">{message}</Tooltip>}
    >
      <button
        type="button"
        style={{
          marginLeft: "5px",
          marginRight: "3px",
          height: "14px",
          marginBottom: "2px",
          width: "14px",
          backgroundColor: "#7F7F7F"
        }}
        onClick={onClick}
        className="btn btn-default btn-circle btn-my"
      >
        <p style={{ marginTop: "-11px" }}>
          <i
            className={`fa fa-${icon ?? 'info'} fa-fw img-circle`}
            style={{ color: "white", fontSize: "8px" }}
          ></i>
        </p>
      </button>
    </OverlayTrigger>
  );
};

export default InfoRoundButton;
